module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "py-3"
  }, [_vm._v("Details")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "change": function($event) {
        return _vm.eventActivateUpdateFlag('DateLocation')
      }
    }
  }, [(_vm.isCreatingSingleEvent) ? _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticClass: "full",
    class: {
      'color-6': _vm.validations.getSelectedEvent.product.$invalid
    }
  }, [_vm._v("\n                    Product"), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [(_vm.isLoadingProductList) ? _c('span', {
    staticClass: "font-size-small dark"
  }, [_vm._v("Loading products")]) : _c('v-select', {
    attrs: {
      "options": _vm.productList,
      "label": "name",
      "placeholder": "Select a product"
    },
    on: {
      "input": _vm.changeProductSelected
    },
    model: {
      value: (_vm.getSelectedEvent.helperProduct),
      callback: function($$v) {
        _vm.$set(_vm.getSelectedEvent, "helperProduct", $$v)
      },
      expression: "getSelectedEvent.helperProduct"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Event Name\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getSelectedEvent.nameAlias),
      expression: "getSelectedEvent.nameAlias"
    }],
    staticClass: "bg-lightest w-100",
    attrs: {
      "type": "text",
      "placeholder": _vm.getSelectedEvent.product ? _vm.getSelectedEvent.product.name : ''
    },
    domProps: {
      "value": (_vm.getSelectedEvent.nameAlias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.getSelectedEvent, "nameAlias", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._m(1), _vm._v(" "), _c('datepicker', {
    attrs: {
      "input-class": "bg-lightest",
      "value": _vm.getSelectedEvent.start,
      "format": "dd/MM/yyyy"
    },
    on: {
      "input": function($event) {
        return _vm.setEventStartDate($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._m(2), _vm._v(" "), _c('timepicker', {
    attrs: {
      "format": "hh:mm",
      "defaultTime": _vm.eventStartHour
    },
    on: {
      "change": _vm.setEventStartTime
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('label', {
    staticClass: "full",
    class: {
      'color-6': _vm.validations.getSelectedEvent.end.$invalid
    }
  }, [_vm._v("\n                    Duration"), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]), _vm._v(" "), (_vm.validations.getSelectedEvent.end.$invalid) ? _c('span', {
    staticClass: "color-6 fs-smaller"
  }, [_vm._v("Select a valid duration")]) : _vm._e()]), _vm._v(" "), _c('timepicker', {
    attrs: {
      "defaultTime": _vm.eventDuration,
      "availableHours": _vm.durationsPossibleHours,
      "format": "hh:mm"
    },
    on: {
      "change": _vm.setEventEndTime
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('label', {
    staticClass: "full",
    class: {
      'color-6': _vm.validations.getSelectedEvent.location.$invalid
    }
  }, [_vm._v("\n                    Location"), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]), _vm._v(" "), (_vm.validations.getSelectedEvent.location.$invalid) ? _c('span', {
    staticClass: "color-6 fs-smaller"
  }, [_vm._v("Enter a location")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getSelectedEvent.location),
      expression: "getSelectedEvent.location"
    }],
    staticClass: "bg-lightest w-100",
    attrs: {
      "type": "text",
      "placeholder": "Type event location"
    },
    domProps: {
      "value": (_vm.getSelectedEvent.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.getSelectedEvent, "location", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), (!_vm.isCreatingSingleEvent) ? _c('div', [_vm._m(3), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-sm-5 pl-0 pt-2"
  }, [_c('label', [_vm._v("Event status")]), _vm._v(" "), _c('v-select', {
    staticClass: "o",
    attrs: {
      "options": _vm.statusList,
      "label": "name",
      "placeholder": "Select a status",
      "value": _vm.getStatusValue
    },
    on: {
      "input": _vm.changeStatusSelected
    }
  })], 1), _vm._v(" "), _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "change": function($event) {
        return _vm.eventActivateUpdateFlag('Status')
      }
    }
  }, [(_vm.getSelectedEvent.status == _vm.statusId('Canceled')) ? _c('div', {
    staticClass: "col-sm-10 mt-3 pl-0"
  }, [_c('label', {
    attrs: {
      "for": "cancellationReason"
    }
  }, [_vm._v("\n                        Cancellation reason\n                        "), (_vm.foundCancellationReasons) ? _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.filteredCancellationReasons.length > 0) ? _c('v-select', {
    staticClass: "open-up-cancelation-reason",
    attrs: {
      "id": "cancellationReason",
      "options": _vm.filteredCancellationReasons,
      "reduce": function (reason) { return reason.id; },
      "label": "description",
      "placeholder": "Select a reason",
      "open-direction": "top"
    },
    on: {
      "input": function($event) {
        return _vm.updateCancellationReason(_vm.cancellationReasonObject)
      }
    },
    model: {
      value: (_vm.cancellationReasonObject),
      callback: function($$v) {
        _vm.cancellationReasonObject = $$v
      },
      expression: "cancellationReasonObject"
    }
  }) : _vm._e(), _vm._v(" "), (!!_vm.cancellationReasonObject && !_vm.getSelectedEvent.cancelationReasonId) ? _c('label', {
    staticClass: "full mt-3",
    staticStyle: {
      "height": "104px"
    }
  }, [_vm._v("\n                        Cancellation description\n                        "), (_vm.foundCancellationReasons) ? _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getSelectedEvent.statusMessage),
      expression: "getSelectedEvent.statusMessage"
    }],
    ref: "cancelationNote",
    staticClass: "bg-lighter w-100 mt-1",
    attrs: {
      "rows": "2"
    },
    domProps: {
      "value": (_vm.getSelectedEvent.statusMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.getSelectedEvent, "statusMessage", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('checkbox', {
    attrs: {
      "name": "allotment",
      "value": "true"
    },
    on: {
      "input": _vm.updateEmailNotification
    },
    model: {
      value: (_vm.notifyEventCancellation),
      callback: function($$v) {
        _vm.notifyEventCancellation = $$v
      },
      expression: "notifyEventCancellation"
    }
  }, [_vm._v("Notify customers by email")])], 1)], 1) : _vm._e()])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-2"
  }, [_c('span', {
    staticClass: "font-weight-600"
  }, [_vm._v("Date/Location")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Event Date"), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Time"), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pt-4 pb-2"
  }, [_c('span', {
    staticClass: "font-weight-600"
  }, [_vm._v("Status")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b8996f1"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/EventEdit/areaDetails.vue
// module id = 1329
// module chunks = 0